<script setup lang="ts">
const route = useRoute();
const localePath = useLocalePath();

const props = defineProps({
  orientation: {
    type: String,
    default: "vertical", // 'vertical' or 'horizontal'
  },
  class: {
    type: String,
    default: "",
  },
});

const emit = defineEmits(["click"]);

const accountPages = [
  "/account",
  "/account/bookings",
  "/account/wallet",
  "/account/visited-locations",
  "/account/product-orders",
  "/account/settings",
];

const pageGroup: Record<string, string[]> = {
  "/account": ["/account", "/account/overdue", "/account/paid"],
  "/account/bookings": ["/account/bookings"],
  "/account/wallet": [
    "/account/wallet",
    "/account/my-gift-cards",
    "/account/my-memberships",
  ],
  "/account/visited-locations": ["/account/visited-locations"],
  "/account/product-orders": ["/account/product-orders"],
  "/account/settings": [
    "/account/settings",
    "/account/change-mobile",
    "/account/change-email",
    "/account/delete-account",
  ],
};

const getPathWithoutLocale = () => {
  const segments = route.path.split("/");
  return segments.length > 1 ? "/" + segments.slice(2).join("/") : route.path;
};

const isActive = (page: string) => {
  const path = getPathWithoutLocale();
  return pageGroup[page]?.includes(path);
};
</script>

<template>
  <div
    :class="[
      props.orientation === 'vertical'
        ? 'flex flex-col space-y-1 lg:space-y-1.5'
        : 'flex overflow-x-auto gap-1.5',
      props.class,
    ]"
  >
    <ULink
      v-for="page in accountPages"
      :key="page"
      :to="localePath(page)"
      :exact="false"
      class="rounded-lg text-sm font-medium first-letter:capitalize transition-colors"
      :class="[
        props.orientation === 'vertical'
          ? 'block px-2 py-3'
          : 'flex-shrink-0 px-4 py-2.5 whitespace-nowrap',
        isActive(page)
          ? 'bg-gray-100 text-deep-indigo hover:!bg-gray-100'
          : 'text-gray-700 hover:bg-gray-50',
      ]"
      @click="emit('click')"
    >
      {{ $t(`label.${page.split("/").pop()?.replace("-", "_")}`) }}
    </ULink>
  </div>
</template>
